import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Metadata } from '@app/modules/payroll/interfaces/paystub-table.interface';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
type ICellRendererParamsWithMetadata = ICellRendererParams & { metadata: Metadata };

@Component({
    imports: [CommonModule, RouterModule],
    standalone: true,
    styleUrls: ['./name.style.scss'],
    templateUrl: './name.template.html',
})
export class EmployeeNameCellRenderer implements ICellRendererAngularComp {
    public value: any;
    public hrId: any;

    agInit(params: ICellRendererParamsWithMetadata): void {
        this.hrId = params.metadata[params.data.id]['employee.name'].hr_employee_id;
        this.value = params.value;
    }

    refresh(params: ICellRendererParams) {
        return false;
    }
}
